
import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}

export function scrollToElement(element: HTMLElement | null) {
  if (!element) return;
  
  // Using both methods for better browser compatibility
  element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  
  // Additional fallback scrolling for devices that might not support scrollIntoView properly
  const yOffset = -20; // Small offset to ensure element is visible
  const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
  
  window.scrollTo({
    top: y,
    behavior: 'smooth'
  });
}
